import { useEffect, useState } from "react";

export const useFileType = (isZip) => {
    const [fileType, setFileType] = useState(".jpg,.jpeg,.png");

    useEffect(() => {
        if (isZip) {
            setFileType("zip,application/zip,application/x-zip,application/x-zip-compressed");
        }
    }, [isZip]);

    return fileType;
};
